import * as React from 'react';

import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

import LoadingIndicator from 'components/LoadingIndicator';
// @ts-ignore
import trackView from 'lib/trackView';

import { ProposedGroup } from './SetupRosterChoose';
import SetupRosteredClassesList from './SetupRosteredClassesList';
import SetupRosterPoll, { SetupRosterPollLoading } from './SetupRosterPoll';

import {
  getProposedGroupsAll,
  getProposedGroupsAll_me_proposed_groups,
} from '../queries/__generated__/getProposedGroupsAll';
import { RosterAll } from '../queries/__generated__/RosterAll';

import GET_PROPOSED_GROUPS_ALL_QUERY from '../queries/GetProposedGroupsAllQuery.gql';
import ROSTER_ALL_MUTATION from '../queries/RosterAllMutation.gql';

type Props = {
  claimClasses: () => Promise<string>;
  proposedGroups: Array<getProposedGroupsAll_me_proposed_groups> | null;
};

type State = {
  statusEndpoint?: string;
};

export class SetupRosterAll extends React.Component<Props, State> {
  state: State = {
    statusEndpoint: '',
  };

  componentDidMount() {
    this.props
      .claimClasses()
      .then(statusEndpoint => {
        this.setState({ statusEndpoint });
      })
      .catch(err => {
        console.error('Claim classes failed', err);
      });
  }

  groupsList() {
    return <SetupRosteredClassesList proposedGroups={this.props.proposedGroups || []} />;
  }

  render() {
    if (!this.props.proposedGroups) {
      return <LoadingIndicator align="center" />;
    }
    // Show the loading screen while we submit the first claim all
    // request. On complete, switch over to start the polling
    if (this.state.statusEndpoint) {
      return (
        <SetupRosterPoll
          statusEndpoint={this.state.statusEndpoint}
          proposedGroups={this.props.proposedGroups}
        />
      );
    } else {
      return <SetupRosterPollLoading groupsList={this.groupsList()} />;
    }
  }
}

const withGroups = graphql(GET_PROPOSED_GROUPS_ALL_QUERY, {
  props: ({ data }) => {
    const { me } = (data as any) as getProposedGroupsAll;
    if (me) {
      return {
        proposedGroups: me.proposed_groups,
      };
    }
    return null;
  },
});

type RosterAllMutation = () => Promise<{ data: RosterAll }>;

const withMutation = graphql(ROSTER_ALL_MUTATION, {
  props({ mutate }) {
    return {
      claimClasses() {
        return ((mutate as any) as RosterAllMutation)().then(
          ({ data: { claimAllProposedClasses } }) => claimAllProposedClasses.status_endpoint
        );
      },
    };
  },
});

// @ts-ignore
export default trackView(withMutation(withGroups(SetupRosterAll)), 'sis_roster_all');
